import { createBrowserRouter } from 'react-router';
import { RootLayout } from './layouts/RootLayout';
import { AuthLayout } from './layouts/AuthLayout';
import { DashboardLayout } from './layouts/DashboardLayout';
import { AdminLayout } from './layouts/AdminLayout';

import { HomePage } from './pages/HomePage';
import { SearchResults } from './pages/buyer/SearchResults';
import { VehicleDetail } from './pages/buyer/VehicleDetail';
import { CompareVehicles } from './pages/buyer/CompareVehicles';
import { Wishlist } from './pages/buyer/Wishlist';

import { Login } from './pages/auth/Login';
import { Register } from './pages/auth/Register';
import { ForgotPassword } from './pages/auth/ForgotPassword';
import { ResetPassword } from './pages/auth/ResetPassword';
import { OTPVerification } from './pages/auth/OTPVerification';
import { AccountCreated } from './pages/auth/AccountCreated';

import { PrivateSellerOnboarding } from './pages/onboarding/PrivateSellerOnboarding';
import { ProfessionalSellerOnboarding } from './pages/onboarding/ProfessionalSellerOnboarding';
import { AddVehicle } from './pages/seller/AddVehicle';
import { SellerComplaints } from './pages/seller/SellerComplaints';
import { SellerComplaintDetail } from './pages/seller/SellerComplaintDetail';

import { LodgeComplaint } from './pages/buyer/LodgeComplaint';
import { ComplaintDetail } from './pages/buyer/ComplaintDetail';
import { MyComplaints } from './pages/buyer/MyComplaints';

import { DashboardOverview } from './pages/dashboard/DashboardOverview';
import { MyListings } from './pages/dashboard/MyListings';
import { Leads } from './pages/dashboard/Leads';
import { Messages } from './pages/dashboard/Messages';
import { Analytics } from './pages/dashboard/Analytics';
import { Subscription } from './pages/dashboard/Subscription';
import { Payments } from './pages/dashboard/Payments';
import { ProfileSettings } from './pages/dashboard/ProfileSettings';

import { DealerDashboard } from './pages/dealer/DealerDashboard';

import { Pricing } from './pages/pricing/Pricing';
import { AboutUs } from './pages/cms/AboutUs';
import { ContactUs } from './pages/cms/ContactUs';
import { FAQ } from './pages/cms/FAQ';
import { PrivacyPolicy } from './pages/cms/PrivacyPolicy';
import { TermsConditions } from './pages/cms/TermsConditions';
import { Blog } from './pages/cms/Blog';
import { BlogDetail } from './pages/cms/BlogDetail';
import { DesignSystem } from './pages/DesignSystem';

import { AdminDashboard } from './pages/admin/AdminDashboard';
import { UserManagement } from './pages/admin/UserManagement';
import { VehicleListings } from './pages/admin/VehicleListings';
import SubscriptionPage from "./pages/auth/SubscriptionPage";
import {LoginOTPVerification} from "./pages/auth/LoginOTPVerification";
import PaymentSuccessPage from "./pages/auth/PaymentSuccessPage";
import PaymentFailurePage from "./pages/auth/PaymentFailurePage";
import PaymentCancelPage from "./pages/auth/PaymentCancelPage";
import ProtectedRoute from "./ProtectedRoute";
import {
  SubscriptionManagement, PaymentManagement, CMSManagement,
  BlogManagement, Reports, SupportTickets, SystemSettings
} from './pages/admin/AdminSubPages';

function SellerRegisterPage() {
  return (
    <div className="min-h-[calc(100vh-180px)] flex items-center justify-center px-4 py-10">
      <Register hideBuyer />
    </div>
  );
}

function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center p-8">
      <div className="text-6xl mb-4">🚗</div>
      <h1 className="text-3xl text-[#2D323A] mb-2">Page Not Found</h1>
      <p className="text-[#717182] mb-6">The road you're looking for doesn't exist.</p>
      <a href="/" className="px-6 py-3 bg-[#1E6DFF] text-white rounded-xl hover:bg-[#1557d9] transition-colors">
        Back to Home
      </a>
    </div>
  );
}

export const router = createBrowserRouter([
  {
    path: '/',
    Component: RootLayout,
    children: [
      { index: true, Component: HomePage },
      { path: 'search', Component: SearchResults },
      { path: 'vehicles/make/:makeId', Component: SearchResults },                          
      { path: 'vehicles/make/:makeId/brand/:brandId', Component: SearchResults },
      { path: 'vehicle/:id', Component: VehicleDetail },
      { path: 'compare', Component: CompareVehicles },
      { path: 'wishlist', Component: Wishlist },
      // { path: 'sell', Component: PrivateSellerOnboarding },
      { path: 'sell', Component: SellerRegisterPage },
      { path: 'sell/professional', Component: ProfessionalSellerOnboarding },
      { path: 'pricing', Component: Pricing },
      { path: 'about', Component: AboutUs },
      { path: 'contact', Component: ContactUs },
      { path: 'faq', Component: FAQ },
      { path: 'privacy', Component: PrivacyPolicy },
      { path: 'terms', Component: TermsConditions },
      { path: 'blog', Component: Blog },
      { path: 'blog/:slug', Component: BlogDetail },
      { path: 'design-system', Component: DesignSystem },
      { path: '*', Component: NotFound },
      
    ],
  },
  {
    path: '/auth',
    Component: AuthLayout,
    children: [
      { path: 'login', Component: Login },
      { path: 'register', Component: Register },
      { path: 'forgot-password', Component: ForgotPassword },
      { path: 'reset-password', Component: ResetPassword },
      { path: 'otp', Component: OTPVerification },
      { path: 'account-created', Component: AccountCreated },
      {path: 'subscription', Component:SubscriptionPage},
      {path: 'login-otp', Component:LoginOTPVerification}
    ],
  },
  {
  path: '/payment',
  Component: AuthLayout,
  children: [
    { path: 'success', Component: PaymentSuccessPage },
    { path: 'failure', Component: PaymentFailurePage },
    { path: 'cancel',  Component: PaymentCancelPage },
  ],
},
    {
  element: <ProtectedRoute allowedRoles={[1]} />,
  Component: RootLayout,
  children: [
    
        { path: 'complaints', Component: MyComplaints },
        { path: 'complaints/new', Component: LodgeComplaint },
        { path: 'complaints/:id', Component: ComplaintDetail },
        { path: "messages", Component: Messages },
       
     
   
  ],
},
  {
  element: <ProtectedRoute allowedRoles={[2]} />,
  children: [
    {
      path: "/dashboard",
      Component: DashboardLayout,
      children: [
        { index: true, Component: DashboardOverview },
        { path: "listings", Component: MyListings },
        { path: "add-vehicle", Component: AddVehicle },
        { path: "listings/:id/edit", Component: AddVehicle },
        { path: "leads", Component: Leads },
        { path: "messages", Component: Messages },
        { path: "analytics", Component: Analytics },
        { path: "subscription", Component: Subscription },
        { path: "payments", Component: Payments },
        { path: "profile", Component: ProfileSettings },
        { path: "complaints", Component: SellerComplaints },
        { path: "complaints/:id", Component: SellerComplaintDetail },
      ],
    },
  ],
},
{
  element: <ProtectedRoute allowedRoles={[3]} />,
  children: [
    {
      path: "/dealer",
      Component: DashboardLayout,
      children: [
        { index: true, Component: DealerDashboard },
        { path: "inventory", Component: MyListings },
        { path: "add-vehicle", Component: AddVehicle },
        { path: "inventory/:id/edit", Component: AddVehicle },
        { path: "leads", Component: Leads },
        { path: "messages", Component: Messages },
        { path: "analytics", Component: Analytics },
        { path: "subscription", Component: Subscription },
        { path: "settings", Component: ProfileSettings },
        { path: "complaints", Component: SellerComplaints },
        { path: "complaints/:id", Component: SellerComplaintDetail },
      ],
    },
  ],
},
  {
    path: '/admin',
    Component: AdminLayout,
    children: [
      { index: true, Component: AdminDashboard },
      { path: 'users', Component: UserManagement },
      { path: 'vehicles', Component: VehicleListings },
      { path: 'subscriptions', Component: SubscriptionManagement },
      { path: 'payments', Component: PaymentManagement },
      { path: 'cms', Component: CMSManagement },
      { path: 'blog', Component: BlogManagement },
      { path: 'reports', Component: Reports },
      { path: 'support', Component: SupportTickets },
      { path: 'settings', Component: SystemSettings },
    ],
  },
]);
